import '../../modules/mode-components';

import * as angular from 'angular';

class LightboxHeaderController {
  private readOnly: boolean;
  private isVizViewPage: boolean;

  constructor() {}

  get backCopy() {
    if (this.isVizViewPage) {
      return 'Back to Visualization';
    }

    return this.readOnly ? 'Back to Report' : 'Back to Editor';
  }
}

const LightboxHeader: angular.IComponentOptions = {
  bindings: {
    onDismiss: '&',
    exploreEnabled: '<',
    sidebarOpen: '<',
    vizTitle: '<',
    vizBreadcrumb: '<',
    vizType: '<',
    onToggleSidebar: '&',
    onClickBreadcrumb: '&',
    readOnly: '<',
    isVizViewPage: '<',
  },
  controller: LightboxHeaderController,
  controllerAs: 'ctrl',
  template: `
<div class="breadcrumb-container" ng-class="{'no-explore': !ctrl.exploreEnabled || (ctrl.vizType !== 'pivot' && ctrl.vizType !== 'vegas')}">
  <span class="close-lightbox" ng-click="ctrl.onDismiss();" ng-class="{'no-viz-title': !ctrl.vizTitle.length}">
    <i class="icon-org-menu-caret back-to-report-icon"></i>
    {{ ctrl.backCopy }}
  </span>
  <div class="viz-title">
    <div class="secondary-breadcrumb">{{ ctrl.vizTitle }}</div>
  </div>
</div>`,
};

angular.module('mode.components').component('lightboxHeader', LightboxHeader);
